var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"main simple"},[_c('router-view'),_c('Notifications')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }